import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

const HeaderTitle = ({ link, title }) => {
  const navigate = useNavigate();

  return (
    <div className="heading-row">
      <div className="left-row-heading-title">
        {link && (
          <div onClick={() => navigate(-1)}>
            <FaArrowLeftLong />
          </div>
        )}
        <div className="headline-content">
          <h1>{title}</h1>
        </div>
      </div>
      <div className="right-row-heading-title"></div>
    </div>
  );
};

export default HeaderTitle;
